import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ApplyPage from './apply/ApplyPage';
import InvestorDocumentsPage from './documents/InvestorDocumentsPage';
import InvestorHomePage from './home/InvestorHomePage';
import InvestorShell from './InvestorShell';
import MessagesPage from './messages/MessagesPage';
import OfferPage from './offers/OfferPage';
import InvestorPaymentsPage from './payments/InvestorPaymentsPage';
import HoldingDetailPage from './portfolio/HoldingDetailPage';
import PortfolioPage from './portfolio/PortfolioPage';
import InvestorProfilePage from './profile/InvestorProfilePage';
import RequestsPage from './requests/RequestsPage';
import TasksPage from './tasks/TasksPage';
import TaxCentrePage from './tax/TaxCentrePage';
import TransactionsPage from './transactions/TransactionsPage';

export default function InvestorRoutes() {
  return (
    <InvestorShell>
      <Routes>
        <Route index element={<InvestorHomePage />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="holdings/:holderId/:classId" element={<HoldingDetailPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="payments" element={<InvestorPaymentsPage />} />
        <Route path="tax" element={<TaxCentrePage />} />
        <Route path="documents" element={<InvestorDocumentsPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="profile" element={<InvestorProfilePage />} />
        <Route path="requests" element={<RequestsPage />} />
        <Route path="apply/:applicationId" element={<ApplyPage />} />
        <Route path="offers/:offerId" element={<OfferPage />} />
        <Route path="*" element={<Navigate to="/investor" replace />} />
      </Routes>
    </InvestorShell>
  );
}
